export enum BalanceTypeDescription {
  LOCK = 'Bloqueio',
  FEE = 'Taxa',
  MOVEMENT = 'Venda',
  MOVEMENT_MAIN = 'Venda Cliente',
  SYSTEM_FEE = 'Taxa',
  SPLIT = 'Split',
  SPLIT_RECEIVED = 'Split recebido',
  SPLIT_SENT = 'Split enviado',
  CUSTOMER_SPLIT = 'Split do Cliente',
  CUSTOMER_SPLIT_RECEIVED = 'Split do cliente recebido',
  CUSTOMER_SPLIT_SENT = 'Split do cliente enviado',
  WITHDRAWAL = 'Saque',
  WITHDRAWAL_ANTECIPATION = 'Antecipação de Recebíveis',
  TRANSFER = 'Transferência',
  TRANSFER_RECEIVED = 'Transferência recebida',
  TRANSFER_SENT = 'Transferência enviada',
  ACCOUNT_RECHARGE = 'Recarga de Conta',
  CARD_RECHARGE = 'Recarga de Cartão',
  DEPOSIT = 'Depósito',
  COMMISSION = 'Comissão',
  SPREAD = 'Spread',
  INSURANCE = 'Seguro',
  ANTECIPATION = 'Antecipação',
}
